import { useState, useEffect } from 'react';
import { breakpoints } from '@/design-system/foundations/theme';

export const mediaQueries = {
  maxMd: `(max-width: ${Number.parseInt(breakpoints.md, 10) - 1}px)`,
  maxLg: `(max-width: ${Number.parseInt(breakpoints.lg, 10) - 1}px)`,
} as const;

export const useMediaQuery = (query: string): boolean => {
  const getMatch = () => typeof window !== 'undefined' && window.matchMedia(query).matches;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const media = window.matchMedia(query);
    const listener = (event: MediaQueryListEvent) => setMatches(event.matches);

    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    if (media.addEventListener) {
      media.addEventListener('change', listener);
      return () => media.removeEventListener('change', listener);
    }

    media.addListener(listener);
    return () => media.removeListener(listener);
  }, [matches, query]);

  return matches;
};
